var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcons16PxStarFilled = function SvgIcons16PxStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.483 5.186-4.028.331-.117.016C.499 5.693.192 6.779.874 7.349l3.033 2.534-.909 3.756-.02.11c-.115.836.795 1.473 1.552 1.031L8 12.758l3.47 2.022.1.052c.769.349 1.639-.34 1.433-1.193l-.91-3.756 3.035-2.534.086-.081c.593-.614.218-1.679-.668-1.751l-4.03-.331-1.565-3.565c-.363-.828-1.538-.828-1.901 0z"
  })));
};
export default SvgIcons16PxStarFilled;